import { render, staticRenderFns } from "./PersonalCompanyForm.vue?vue&type=template&id=61dd68ef&scoped=true&"
import script from "./PersonalCompanyForm.vue?vue&type=script&lang=js&"
export * from "./PersonalCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd68ef",
  null
  
)

export default component.exports